module.exports = __webpack_public_path__ + "img/Cornelis vd Lijnstraat na.9d5a4c96.jpg";